// @flow
import $ from 'jquery';
import WebComponent from 'fg-frontend/src/webComponents/WebComponent';
import fancybox from '@fancyapps/fancybox/dist/jquery.fancybox';

const fragments = {
  ITEM: '[data-fragment="Gallery.item"]'
};

export default class Gallery extends WebComponent {
  constructor (props) {
    super(props);
  }

  didMount() {
    $().fancybox({
      selector : fragments.ITEM,
      buttons: [
        "close"
      ]
    });
  }

  willUnMount() {

  }
}



// WEBPACK FOOTER //
// ./fe/web-default/src/js/components/Gallery.js